export const getThemeColor =
  (colorName: any) =>
  ({ theme }: any) => {
    return theme?.colors[colorName];
  };
